import { vi } from "./vi";

export const transData = {
    vi,
}
